var accordeon;

accordeon = function() {
  var $, accordion, module, moduleName;
  $ = require('jquery');
  require('../../../_scripts/functions/easings')($);
  moduleName = 'accordion';
  module = $("." + moduleName);
  accordion = function(params) {
    var activeClass, contentWrapperClass, easing, isFirstEnable, timeDirection, wrapper, wrapperClass;
    wrapperClass = params.wrapperClassName;
    contentWrapperClass = params.contentWrapperClassName;
    activeClass = params.bemActiveClassName;
    isFirstEnable = params.enableFirst;
    easing = params.easing;
    wrapper = $("." + wrapperClass);
    timeDirection = params.timeDirection;
    return wrapper.each(function(i) {
      var contentWrapper, thisWrp, toggleAction;
      thisWrp = $(this);
      contentWrapper = thisWrp.find("." + contentWrapperClass);
      toggleAction = function() {
        if (!thisWrp.hasClass(wrapperClass + "--" + activeClass)) {
          contentWrapper.animate({
            height: 'show',
            opacity: 'show'
          }, timeDirection, easing);
          contentWrapper.animate;
        } else {
          contentWrapper.animate({
            height: 'hide',
            opacity: 'hide'
          }, timeDirection, easing);
        }
        thisWrp.toggleClass(wrapperClass + "--" + activeClass);
        return setTimeout(function() {
          return thisWrp.removeClass(wrapperClass + "--block-click");
        }, timeDirection);
      };
      thisWrp.click(function() {
        return toggleAction();
      });
      if (isFirstEnable && i === 0) {
        return thisWrp.trigger('click');
      }
    });
  };
  return accordion({
    wrapperClassName: 'accordion__spoiler',
    contentWrapperClassName: 'accordion__content',
    bemActiveClassName: 'enabled',
    timeDirection: 800,
    enableFirst: true,
    easing: 'easeInOutCirc'
  });
};

module.exports = accordeon;
